// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCheckMemberNumberDefaultResponse {
    static getAttributeTypeMap() {
        return EnrollmentCheckMemberNumberDefaultResponse.attributeTypeMap;
    }
}
EnrollmentCheckMemberNumberDefaultResponse.discriminator = undefined;
EnrollmentCheckMemberNumberDefaultResponse.additionalProperties = false;
EnrollmentCheckMemberNumberDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentIsValidMemberNumberModel"
    },
];
//# sourceMappingURL=enrollmentCheckMemberNumberDefaultResponse.js.map